module.exports = __webpack_public_path__ + "static/Diagram-1-05f66e2993ebadbc34e001127584f32b.png";